<template>
  <div class="workflowactionlog pa-2" v-if="$can('workflow_actions_view')">
    <v-row justify="center">
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="filterDialog"
      >
        <v-card>
          <v-card-title color="primary" dark flat
            >{{ $t("searchFilterMsg") }}
            <v-spacer></v-spacer>
            <v-btn icon @click="filterDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-layout column class="mt-5 ma-3">
              <v-flex xs12 class="mt-5">
                <v-layout row wrap>
                  <v-flex xs6>
                    <div align="left" v-if="advanceSearch.active == true">
                      <v-btn
                        depressed
                        class="green text-none"
                        @click="restAdvSearch()"
                      >
                        {{ $t("resetSearchMsg") }}
                        <v-icon right>mdi-recycle</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div align="right">
                      <v-btn
                        depressed
                        class="secondary text-none"
                        :loading="advanceSearch.loading"
                        @click="advSearch()"
                      >
                        {{ $t("advancedSearchMsg") }}
                        <v-icon right>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="applicationDialog"
        hide-overlay
        transition="dialog-bottom-transition"
        maxWidth="1200"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title class="pl-9">{{ $t("applicationMsg") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="pr-9" icon dark @click="applicationDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-8">
            <application
              v-if="renderApplication"
              :application="application"
              :workflow_action_building="workflow_action_building"
              :submissionFormData="submissionFormData"
              :currentTab="tab_name"
              @reloadWorkflowActions="reloadWorkflowActions"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="attachmentDialog"
        hide-overlay
        transition="dialog-bottom-transition"
        max-width="1000"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="attachmentDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{
              $t("workflowAttachmentsMsg")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="4000" top :color="color">
      <span>{{ $t(message) }}</span>
    </v-snackbar>
    <v-container>
      <v-layout column class="pt-5">
        <v-flex xs12>
          <h1>{{ $t("workflowActionsMsg") }}</h1>
          <v-breadcrumbs>
            <v-breadcrumbs-item disabled v-if="dashBreadcrumb">
              {{ $t("dashboardMsg") }}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              v-if="!dashBreadcrumb"
              @click="changeView('default')"
            >
              <a>{{ $t("dashboardMsg") }}</a></v-breadcrumbs-item
            >
            <v-breadcrumbs-divider v-if="!dashBreadcrumb"
              >/
            </v-breadcrumbs-divider>
            <v-breadcrumbs-item disabled v-if="showBreadcrumb">
              {{ $t("viewWorkflowActionLogsMsg") }}
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <div v-if="view == 'default'">
          <v-flex xs12 class="mt-5 mb-2">
            <div class="mx-5">
              <v-layout row wrap>
                <v-flex xs12 md2 class="hidden-sm-and-down"></v-flex>
                <v-flex xs12 md2>
                  <div class="pa-1">
                    <v-btn
                      class="primary text-none white--text"
                      depressed
                      block
                      @click="filterDialog = true"
                    >
                      {{ $t("filterMsg") }}
                      <v-icon right>mdi-tune</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12 md4>
                  <div class="pa-1">
                    <v-text-field
                      class="text_field header"
                      outlined
                      dense
                      :label="$t('searchMsg')"
                      append-icon="mdi-undo-variant"
                      @click:append="resetSearch()"
                      v-on:keyup.enter="search"
                      v-model="searchTerm"
                      @input="enableSearch()"
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs12 md2>
                  <div class="pa-1">
                    <v-btn
                      class="secondary text-none"
                      depressed
                      block
                      @click="search"
                      :loading="searchLoader"
                      :disabled="searchButtonDisabled"
                    >
                      {{ $t("searchMsg") }}
                      <v-icon right>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12 md2 class="hidden-sm-and-down"></v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-divider class="mt-5 mx-5"></v-divider>
          <v-flex xs12 class="mt-3">
            <v-tabs show-arrows="">
              <v-tabs-slider color="secondary"></v-tabs-slider>
              <v-tab
                class="text-none"
                @click="switchTab('pending_applications')"
                ><h3>{{ $t("pendingApplicationsMsg") }}</h3></v-tab
              >
              <v-tab class="text-none" @click="switchTab('approval_history')"
                ><h3>{{ $t("approvalHistoryMsg") }}</h3></v-tab
              >
            </v-tabs>
          </v-flex>
          <div v-if="tab_name == 'pending_applications'">
            <v-flex xs12 class="mt-5">
              <div v-if="workflowactionlog.length == 0">
                <v-card elevation="0">
                  <v-layout row wrap>
                    <v-flex xs12 md1>
                      <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-icon large class="primary--text">
                              mdi-alert-circle-outline
                            </v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md11>
                      <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">{{
                            $t("noApprovalsFoundMsg")
                          }}</v-col>
                        </v-row>
                      </v-container>
                    </v-flex>
                  </v-layout>
                </v-card>
              </div>
              <div v-else>
                <v-progress-linear
                  v-if="workflowactionlogLoader"
                  height="1"
                  indeterminate
                  color="primary"
                ></v-progress-linear>
                <div class="hidden-sm-and-down">
                  <v-card elevation="0" class="pa-2">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr class="secondary white--text">
                            <th class="text-left white--text">
                              {{ $t("receivedMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("workflowMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("applicationDetailsMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("applicationFormMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("workflowActionMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("commentsMsg") }}
                            </th>
                            <th class="text-right white--text"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in workflowactionlog" :key="item.id">
                            <td v-if="item.workflow_status.code != 'DEF'">
                              {{
                                item.created_at | moment("DD/MM/YYYY - hh:mm a")
                              }}
                            </td>
                            <td v-if="item.workflow_status.code != 'DEF'">
                              {{ item.workflow.workflow_name }}
                            </td>
                            <td
                              v-if="item.workflow_status.code != 'DEF'"
                              v-html="item.application_details"
                            ></td>
                            <td v-if="item.workflow_status.code != 'DEF'">
                              <v-btn
                                depressed
                                class="primary text-none"
                                small
                                @click="showApplication(item.application, item)"
                                >{{ $t("viewMsg") }}
                                <v-icon right> mdi-eye</v-icon>
                              </v-btn>
                            </td>
                            <td
                              style="max-width: 200px"
                              v-if="
                                item.workflow_status.code != 'DEF' &&
                                item.is_active == true
                              "
                            >
                              <v-select
                                :items="[$t('approveMsg'), $t('rejectMsg')]"
                                :hint="$t('selectActionMsg')"
                                v-model="item.workflow_action"
                                label=""
                                persistent-hint
                                :rules="inputRules"
                              ></v-select>
                            </td>
                            <td
                              v-if="
                                item.workflow_status.code != 'DEF' &&
                                item.is_active != true
                              "
                            >
                              {{ item.action_taken }}
                            </td>
                            <td
                              v-if="
                                item.workflow_status.code != 'DEF' &&
                                item.is_active == true
                              "
                            >
                              <v-textarea
                                class="mt-1"
                                auto-grow
                                rows="1"
                                row-height="5"
                                outlined
                                v-model="item.comment"
                                :rules="inputRules"
                              >
                              </v-textarea>
                            </td>
                            <td
                              v-if="
                                item.workflow_status.code != 'DEF' &&
                                item.is_active != true
                              "
                            >
                              {{ item.comment }}
                            </td>
                            <td v-if="item.workflow_status.code != 'DEF'">
                              <div align="right" v-if="item.is_active == true">
                                <v-btn
                                  depressed
                                  class="success text-none"
                                  small
                                  @click="submitAction(item)"
                                  :loading="loading && submitIndex == item.id"
                                  >{{ $t("submitMsg") }}
                                  <v-icon right> mdi-arrow-top-right</v-icon>
                                </v-btn>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </div>
                <div class="hidden-md-and-up">
                  <v-layout column>
                    <template
                      v-for="(workflowaction, index) in workflowactionlog"
                    >
                      <div :key="index">
                        <v-flex xs12 class="mb-2">
                          <v-card elevation="0">
                            <div class="pa-5">
                              <v-layout column>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex xs11>
                                      <div class="title primary--text">
                                        <b>{{
                                          workflowaction.workflow.workflow_name
                                        }}</b>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-divider class="mt-2"></v-divider>
                                <v-flex xs12 class="mt-1">
                                  <v-layout column>
                                    <v-flex xs12 class="mt-1">
                                      <div>
                                        {{ workflowaction.workflow_id }}
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 class="mt-1"></v-flex>
                                    <v-flex xs12 class="mt-5">
                                      <v-layout row wrap>
                                        <v-flex xs6>
                                          <div class="pa-1">
                                            <v-btn
                                              depressed
                                              class="green darken-1 text-none white--text"
                                              block
                                              @click="
                                                submitAction(workflowaction)
                                              "
                                              :loading="
                                                loading &&
                                                submitIndex == workflowaction.id
                                              "
                                              >{{ $t("submitMsg") }}
                                              <v-icon right>
                                                mdi-border-color
                                              </v-icon>
                                            </v-btn>
                                          </div>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-card>
                        </v-flex>
                      </div>
                    </template>
                  </v-layout>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 class="mt-5">
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <div v-if="length != 0">
                    <b class="primary--text ml-4">{{ $t("totalMsg") }} </b
                    >{{ workflowactionlogPagination.total | formatNumber }}
                  </div>
                </v-flex>
                <v-flex xs12 md9>
                  <div align="right">
                    <v-pagination
                      v-if="length != 0 && length != 1"
                      :length="length"
                      total-visible="10"
                      v-model="workflowactionlogPagination.current_page"
                      @input="changePage()"
                      circle
                    >
                    </v-pagination>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </div>
          <div v-if="tab_name == 'approval_history'">
            <v-flex xs12 class="mt-5">
              <div v-if="wfactionlogactioned.length == 0">
                <v-card elevation="0">
                  <v-layout row wrap>
                    <v-flex xs12 md1>
                      <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-icon large class="primary--text">
                              mdi-alert-circle-outline
                            </v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md11>
                      <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            {{ $t("noApprovalsFoundMsg") }}</v-col
                          >
                        </v-row>
                      </v-container>
                    </v-flex>
                  </v-layout>
                </v-card>
              </div>
              <div v-else>
                <v-progress-linear
                  v-if="wfactionlogActionedLoader"
                  height="1"
                  indeterminate
                  color="primary"
                ></v-progress-linear>
                <div class="hidden-sm-and-down">
                  <v-card elevation="0" class="pa-2">
                    <div class="d-flex justify-space-between mb-2">
                      <v-btn
                        class="blue text-none white--text"
                        small
                        :href="pdfUrl"
                        target="_blank"
                        :loading="loading"
                      >
                        {{ $t("exportPdfMsg") }}
                        <v-icon right> mdi-printer</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>

                      <v-btn
                        class="success text-none white--text"
                        small
                        :href="csvUrl"
                        target="_blank"
                        :loading="loading"
                      >
                        {{ $t("exportCsvMsg") }}
                        <v-icon right> mdi-file-download</v-icon>
                      </v-btn>
                    </div>

                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr class="secondary white--text">
                            <th class="text-left white--text">
                              {{ $t("receivedMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("workflowMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("applicationDetailsMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("applicationFormMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("workflowActionMsg") }}
                            </th>
                            <th class="text-left white--text">
                              {{ $t("commentsMsg") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in wfactionlogactioned"
                            :key="item.id"
                          >
                            <td>
                              {{
                                item.created_at | moment("DD/MM/YYYY - hh:mm a")
                              }}
                            </td>
                            <td>{{ item.workflow.workflow_name }}</td>
                            <td v-html="item.application_details"></td>
                            <td>
                              <v-btn
                                depressed
                                class="primary text-none"
                                small
                                @click="showApplication(item.application)"
                              >
                                {{ $t("viewMsg") }}
                                <v-icon right> mdi-eye</v-icon>
                              </v-btn>
                            </td>
                            <td>{{ item.action_taken }}</td>
                            <td>{{ item.comment }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </div>
                <div class="hidden-md-and-up">
                  <v-layout column>
                    <template
                      v-for="(workflowaction, index) in wfactionlogactioned"
                    >
                      <div :key="index">
                        <v-flex xs12 class="mb-2">
                          <v-card elevation="0">
                            <div class="pa-5">
                              <v-layout column>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex xs11>
                                      <div class="title primary--text">
                                        <b>{{
                                          workflowaction.workflow.workflow_name
                                        }}</b>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-divider class="mt-2"></v-divider>
                                <v-flex xs12 class="mt-1">
                                  <v-layout column>
                                    <v-flex xs12 class="mt-1">
                                      <div>
                                        {{ workflowaction.workflow_id }}
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 class="mt-1"></v-flex>
                                    <v-flex xs12 class="mt-5">
                                      <v-layout row wrap>
                                        <v-flex xs6>
                                          <div class="pa-1">
                                            <v-btn
                                              depressed
                                              class="green darken-1 text-none white--text"
                                              block
                                              @click="
                                                submitAction(workflowaction)
                                              "
                                              :loading="
                                                loading &&
                                                submitIndex == workflowaction.id
                                              "
                                              >{{ $t("submitMsg") }}
                                              <v-icon right>
                                                mdi-border-color
                                              </v-icon>
                                            </v-btn>
                                          </div>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-card>
                        </v-flex>
                      </div>
                    </template>
                  </v-layout>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 class="mt-5">
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <div v-if="lengthApp != 0">
                    <b class="primary--text ml-4">{{ $t("totalMsg") }} </b
                    >{{ wfactionlogActionedPagination.total }}
                  </div>
                </v-flex>
                <v-flex xs12 md9>
                  <div align="right">
                    <v-pagination
                      v-if="lengthApp != 0 && lengthApp != 1"
                      :length="lengthApp"
                      total-visible="10"
                      v-model="wfactionlogActionedPagination.current_page"
                      @input="changePageAppHistory()"
                      circle
                    >
                    </v-pagination>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </div>
        </div>
        <div v-if="view == 'create'">
          <v-flex class="mt-5">
            <v-card elevation="0">
              <v-card-title class="primary white--text">
                <v-spacer></v-spacer>
                <div v-if="newworkflowactionlog.id == null">
                  {{ $t("addworkflowActionLogyMsg") }}
                </div>
                <div v-else>{{ $t("editworkflowActionLogMsg") }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="changeView('default')">
                  <v-icon class="white--text"> mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-layout row wrap class="mt-5">
                    <v-flex xs12 md6>
                      <div class="pa-3"></div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  class="secondary text-none mt-3"
                  @click="save"
                  :disabled="!valid"
                  :loading="loading"
                >
                  {{ $t("saveMsg") }}
                  <v-icon right> mdi-content-save</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </div>

        <div v-if="view == 'show'">
          <v-card elevation="0" class="pa-3">
            <div></div>
          </v-card>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import application from "@/views/admin/workflow/application.vue";
import apiCall from "@/utils/api";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";

var numeral = require("numeral");
Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,0");
});
Vue.filter("formatMoney", function (value) {
  return numeral(value).format("0,0.00");
});
export default {
  components: {
    application,
  },
  data() {
    return {
      dashBreadcrumb: true,
      showBreadcrumb: false,
      applicationDialog: false,
      attachmentDialog: false,
      afterApprovalDialog: false,

      renderApplication: false,
      filterDialog: false,
      view: "default",
      page: 1,
      loading: false,
      valid: true,
      message: "",
      color: "",
      delete: false,
      workflowactionlogIndex: null,
      snackbar: false,
      inputRules: [
        (v) => !!v || this.$t("inputIsRequiredMessage"),
        (v) =>
          !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(v) ||
          this.$t("mustNotHaveASpecialCharacterMsg"),
      ],
      searchTerm: null,
      searchLoader: false,
      searchButtonDisabled: false,
      Url: null,
      pdfUrl: null,
      csvUrl: null,
      filteredworkflowactionlog: false,
      submitIndex: null,
      tab_name: "pending_applications",
      application: {},
      newworkflowactionlog: {
        workflow_id: null,
      },
      displayworkflowactionlog: {
        workflow_id: null,
      },

      advanceSearch: {
        active: false,
        loading: false,
      },
      submissionFormData: null,
    };
  },
  created() {
    if (this.$can("workflow_actions_view")) {
      this.correctPagination();

      this.fetchwfactionlogactioned(
        this.wfactionlogActionedPagination.current_page
      );
    }
    this.getSubmissionFormData();
  },
  methods: {
    ...mapActions([
      "fetchworkflowactionlog",
      "startworkflowactionlogLoader",
      "stopworkflowactionlogLoader",
      "filterworkflowactionlog",
      "fetchwfactionlogactioned",
      "startwfactionlogActionedLoader",
      "stopwfactionlogActionedLoader",
      "filterwfactionlogactioned",
    ]),

    reloadWorkflowActions() {
      this.changeView("default");
      this.fetchworkflowactionlog(1);
      this.applicationDialog = false;
    },
    enableSearch() {
      this.searchButtonDisabled = false;
    },
    resetSearch() {
      this.searchTerm = null;
      this.startworkflowactionlogLoader();
      this.fetchworkflowactionlog(1);
      this.filteredworkflowactionlog = false;
    },
    showworkflowactionlog(workflowactionlog) {
      this.displayworkflowactionlog.workflow_id = workflowactionlog.workflow_id;
      this.changeView("show");
    },
    editworkflowactionlog(workflowactionlog) {
      this.newworkflowactionlog.id = workflowactionlog.id;
      this.newworkflowactionlog.workflow_id = workflowactionlog.workflow_id;
      this.changeView("create");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.newworkflowactionlog.id != null) {
          apiCall({
            url: "/api/workflowactionlog/" + this.newworkflowactionlog.id,
            data: this.newworkflowactionlog,
            method: "PUT",
          })
            .then((resp) => {
              this.message = this.$t("workflowActionLogupdatedsuccessMsg");
              this.color = "orange";
              this.loading = false;
              this.snackbar = true;
              this.changeView("default");
              this.correctPagination();
            })
            .catch((error) => {
              this.message = this.$t("anErrorOccurredMsg");
              this.color = "error";
              this.loading = false;
              this.snackbar = true;
            });
        } else {
          apiCall({
            url: "/api/workflowactionlog",
            data: this.newworkflowactionlog,
            method: "POST",
          })
            .then((resp) => {
              this.message = this.$t("workflowActionLogaddedsuccessMsg");
              this.color = "success";
              this.loading = false;
              this.snackbar = true;
              this.changeView("default");
              this.correctPagination();
            })
            .catch((error) => {
              this.message = this.$t("anErrorOccurredMsg");
              this.color = "error";
              this.loading = false;
              this.snackbar = true;
            });
        }
      }
    },
    search() {
      if (this.searchTerm == null) {
        this.searchButtonDisabled = true;
      } else {
        this.searchLoader = true;
        this.searchButtonDisabled = false;
        this.startworkflowactionlogLoader();
        apiCall({
          url: "/api/workflowactionlog?type=search&search=" + this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filterworkflowactionlog(resp);
            this.searchLoader = false;
            this.stopworkflowactionlogLoader();
            this.filteredworkflowactionlog = true;
          })
          .catch((error) => {
            console.log(error.response);
            this.searchLoader = false;
            this.stopworkflowactionlogLoader();
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
          });
      }
    },
    changeView(view) {
      if (view == "default") {
        this.newworkflowactionlog.id = null;
        this.newworkflowactionlog.workflow_id = null;
        this.dashBreadcrumb = true;
        this.showBreadcrumb = false;
      } else if (view == "create") {
      } else if (view == "show") {
        this.dashBreadcrumb = false;
        this.showBreadcrumb = true;
      }
      this.view = view;
    },

    restAdvSearch() {
      this.startbusinessLoader();
      this.filterDialog = false;
      this.advanceSearch.active = false;
      this.advanceSearch.customer_name = null;
      this.advanceSearch.customer_number = null;
      this.advanceSearch.business_name = null;
      this.advanceSearch.id_number = null;
      this.advanceSearch.sub_county_name = null;
      this.advanceSearch.phone_number = null;
      this.advanceSearch.receipt_number = null;
      this.advanceSearch.sbp_number = null;

      this.fetchbusiness(1);
    },

    advSearch() {
      this.advanceSearch.loading = true;
      this.startbusinessLoader();
      apiCall({
        url: "/api/workflowactionlog?type=advance_search",
        method: "GET",
      })
        .then((resp) => {
          this.filterworkflowactionlog(resp);
          this.advanceSearch.active = true;
          this.advanceSearch.loading = false;
          this.stopworkflowactionlogLoader();
          this.filteredbusiness = true;
          this.filterDialog = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.advanceSearch.loading = false;
          this.stopworkflowactionlogLoader();
          this.message = this.$t("anErrorOccurredMsg");
          this.color = "error";
          this.snackbar = true;
        });
    },

    changePage() {
      if (this.filteredworkflowactionlog == true) {
        this.searchButtonDisabled = false;
        this.startworkflowactionlogLoader();
        apiCall({
          url:
            "/api/workflowactionlog?page=" +
            this.workflowactionlogPagination.current_page +
            "&type=search&search=" +
            this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filterworkflowactionlog(resp);
            this.stopworkflowactionlogLoader();
          })
          .catch((error) => {
            console.log(error.response);
            this.stopworkflowactionlogLoader();
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
          });
      } else {
        this.fetchworkflowactionlog(
          this.workflowactionlogPagination.current_page
        );
      }
    },

    changePageAppHistory() {
      if (this.filterwfactionlogactioned == true) {
        this.searchButtonDisabled = false;
        this.startwfactionlogActionedLoader();
        apiCall({
          url:
            "/api/workflowactionlog?tab=approval_history&page=" +
            this.wfactionlogActionedPagination.current_page +
            "&type=search&search=" +
            this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filterwfactionlogactioned(resp);
            this.stopwfactionlogActionedLoader();
          })
          .catch((error) => {
            console.log(error.response);
            this.stopwfactionlogActionedLoader();
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
          });
      } else {
        this.fetchwfactionlogactioned(
          this.wfactionlogActionedPagination.current_page
        );
      }
    },

    deleteworkflowactionlog(item) {
      confirm(this.$t("workflowActionLogdeletewarningMsg")) &&
        (this.delete = true);
      if (this.delete) {
        this.loading = true;
        this.workflowactionlogIndex = item.id;
        apiCall({
          url: "/api/workflowactionlog/" + item.id,
          method: "DELETE",
        })
          .then((resp) => {
            this.message = this.$t("workflowActionLogdeletesuccessMsg");
            this.color = "success";
            this.snackbar = true;
            this.loading = false;
            this.delete = false;
            this.workflowactionlogIndex = null;
            this.fetchworkflowactionlog(
              this.workflowactionlogPagination.current_page
            );
          })
          .catch((error) => {
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
            this.loading = false;
            this.delete = false;
            this.workflowactionlogIndex = null;
            console.log(error.response);
          });
      }
    },
    submitAction(workflowaction) {
      if (workflowaction.workflow_action != null) {
        confirm(this.$t("workflowActionLogSubmitConfirmationMsg")) &&
          (this.submit = true);
        if (this.submit) {
          this.loading = true;
          this.submitIndex = workflowaction.id;
          apiCall({
            url: "/api/workflowactionlog/action",
            data: workflowaction,
            method: "POST",
          })
            .then((resp) => {
              this.message = this.$t("workflowActionLogSubmitSuccessMsg");
              this.color = "success";
              this.loading = false;
              this.snackbar = true;
              this.submitIndex = null;
              this.changeView("default");
              this.correctPagination();
            })
            .catch((error) => {
              this.message = this.$t("anErrorOccurredMsg");
              this.color = "error";
              this.loading = false;
              this.snackbar = true;
              this.submitIndex = null;
            });

          this.submit = false;
        }
      } else {
        this.message = this.$t("workflowActionBlankErrorMsg");
        this.color = "error";
        this.loading = false;
        this.snackbar = true;
      }
    },
    correctPagination() {
      let currentPage = this.workflowactionlogPagination.current_page;
      // If the current page is a multiple of 20
      if (currentPage !== 1) {
        if ((this.workflowactionlogPagination.total - 1) % 20 === 0) {
          currentPage = currentPage - 1;
        }
      }
      this.fetchworkflowactionlog(currentPage);
    },
    switchTab(tab) {
      this.tab_name = tab;
      if (tab == "pending_applications") {
        this.fetchworkflowactionlog(
          this.workflowactionlogPagination.current_page
        );
      }
      if (tab == "approval_history") {
        this.fetchwfactionlogactioned(
          this.wfactionlogActionedPagination.current_page
        );

        this.Url = "/api/workflowactionlog?tab=approval_history";

        this.pdfUrl = this.Url + "&download=pdf";
        this.csvUrl = this.Url + "&download=csv";
      }
    },
    showApplication(application, workflow_action) {
      this.renderApplication = true;
      this.application = application;
      this.workflow_action_building = workflow_action;
      this.applicationDialog = true;
    },

    openAttachmentDialog(application) {
      //this.renderApplication = true;
      //this.application = application;
      this.attachmentDialog = true;
    },

    getSubmissionFormData() {
      apiCall({
        url: "/api/submission?type=formData",
        method: "GET",
      })
        .then((resp) => {
          this.submissionFormData = resp;
        })
        .catch((error) => {
          this.message = this.$t("anErrorOccurredMsg");
          this.color = "error";
        });
    },
  },
  computed: {
    ...mapGetters([
      "workflowactionlog",
      "workflowactionlogPagination",
      "workflowactionlogLoader",
      "wfactionlogactioned",
      "wfactionlogActionedPagination",
      "wfactionlogActionedLoader",
    ]),
    length: function () {
      return Math.ceil(
        this.workflowactionlogPagination.total /
          this.workflowactionlogPagination.per_page
      );
    },
    lengthApp: function () {
      return Math.ceil(
        this.wfactionlogActionedPagination.total /
          this.wfactionlogActionedPagination.per_page
      );
    },
  },
  watch: {
    applicationDialog: function (newValue, old) {
      if (!newValue) {
        this.renderApplication = false;
      }
    },
  },
};
</script>
